import React from 'react';
import { Col, Button } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import Header from '../components/Layout/Header';
import Sidebar from '../components/Layout/Sidebar';
import Main from '../components/Layout/Main';

const UnauthorizedPage = () => {
    const navigate = useNavigate();

    const handleGoBack = () => {
        // go back minus one in history
        navigate(-1)
    };

    return (
        <React.Fragment>
            <Header />
            <Sidebar />
            <Main>
            <div className="niceadmin">
                <main>
                    <div className="container">
                        <Col>
                            <h1 className="display-1">403</h1>
                            <h2>Unauthorized Access</h2>
                            <p className="lead">
                                Sorry, you don’t have permission to view this page.
                            </p>
                            <Button variant="primary" onClick={handleGoBack}>
                                Go Back
                            </Button>
                        </Col>
                    </div>
                </main>
            </div>
            </Main>
        </React.Fragment>
    );
};

export default UnauthorizedPage;


// {
//     "paymentTypeId": 0,
//     "paymentTypeName": "Mpesa"
//   },
//   {
//     "paymentTypeId": 1,
//     "paymentTypeName": "Wallet"
//   },
//   {
//     "paymentTypeId": 2,
//     "paymentTypeName": "New_Conversions"
//   },
//   {
//     "paymentTypeId": 3,
//     "paymentTypeName": "Operational_Loss"
//   },
//   {
//     "paymentTypeId": 4,
//     "paymentTypeName": "Bank_Transfer"
//   },
//   {
//     "paymentTypeId": 5,
//     "paymentTypeName": "Salary"
//   },
//   {
//     "paymentTypeId": 6,
//     "paymentTypeName": "Insurance"
//   },
//   {
//     "paymentTypeId": 7,
//     "paymentTypeName": "Voucher"
//   },
//   {
//     "paymentTypeId": 8,
//     "paymentTypeName": "Calibration"
//   },
//   {
//     "paymentTypeId": 9,
//     "paymentTypeName": "Compesation_Fuel"
//   }